import { ConfirmationDialogRunning } from 'components/atoms/ConfirmationDialogRunning'
import {
	$contactColumns,
	$contactStyles,
	columnHeaders,
	sortKeys
} from 'features/contacts/utils/columns'
import { ExecutionsUI } from 'features/executions'
import { memo } from 'react'
import { ContactsTable, SearchPagination } from 'shared/ui'

import type { ContactTable as Props } from '../../types'

import { AddToCampaign } from '../AddToCampaign/AddToCampaign'
import { CreateCampaign } from '../CreateCampaign/CreateCampaign'
import { CSVExport } from '../CSVExport'
import { DeleteContacts } from '../DeleteContacts/DeleteContacts'
import { SendToTeamMember } from '../SendToTeamMember'
import { ContactsRow } from './InfoCells'

const Headers = () => [
	<ContactsTable.SortableHeadCells
		columnsStore={$contactColumns}
		headlineDictionary={columnHeaders}
		key='🎩s'
		sortDictionary={sortKeys}
	/>,
	ContactsTable.ActionTH
]

const HeaderActions = (props: ContactsTable.Types.ActionsProps) => [
	<CSVExport
		className={ContactsTable.css.activeControlButton}
		{...props}
		key='📦'
	/>,
	<SendToTeamMember
		className={ContactsTable.css.activeControlButton}
		{...props}
		key='👥'
	/>,
	<AddToCampaign
		className={ContactsTable.css.activeControlButton}
		{...props}
		key='➕'
	/>,
	<CreateCampaign
		className={ContactsTable.css.activeControlButton}
		{...props}
		key='📝'
	/>,

	<DeleteContacts
		// className={ContactsTable.css.activeControlButton}
		{...props}
		key='🗑️'
	/>
]

const GeneralTable_ = ({ contacts, filter, total }: Props) => (
	<>
		<ContactsTable.Wrapper store={$contactStyles}>
			<ContactsTable.SelectWrap
				Actions={HeaderActions}
				filter={filter}
				Headers={Headers}
				items={contacts}
				Row={ContactsRow}
				total={total}
			/>
		</ContactsTable.Wrapper>
		<SearchPagination total={total} />
		<ExecutionsUI.PopoverInfo />
		<ConfirmationDialogRunning />
	</>
)

export const GeneralTable = memo(GeneralTable_)
